var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiParser = void 0;
const react_1 = __importDefault(require("react"));
const parse_table_1 = require("./parse-table");
const parse_new_lines_1 = require("./parse-new-lines");
const parse_stars_to_bold_1 = require("./parse-stars-to-bold");
exports.MultiParser = (props) => {
    if (parse_table_1.validTable(props.children)) {
        return (react_1.default.createElement(parse_table_1.ParseTable, { is: props.is, wheel: props.wheel }, props.children));
    }
    if (parse_stars_to_bold_1.hasStar(props.children)) {
        return (react_1.default.createElement(parse_stars_to_bold_1.ParseStarsToBold, { is: props.is, wheel: props.wheel }, props.children));
    }
    return (react_1.default.createElement(parse_new_lines_1.ParseNewLines, { is: props.is, wheel: props.wheel }, props.children));
};
//# sourceMappingURL=multi-parser.js.map